import React from 'react'
import { Create, SimpleForm, TextInput, ReferenceInput, SelectInput, NumberInput, AutocompleteInput } from 'react-admin'

const NotInterestedTagsCreate = () => (
    <Create redirect="show" >
        <SimpleForm >
            <TextInput source="label" />
            <NumberInput source="position" />
            <ReferenceInput
                source="client.id"
                reference="clients"
                sort={{ field: 'name', order: 'ASC' }}
                perPage={1000}
            >
                <AutocompleteInput
                    source="name"
                    optionText="name"
                    filterToQuery={(searchText) => ({ name: searchText })}
                />
            </ReferenceInput>
        </SimpleForm>
    </Create>
)

export default NotInterestedTagsCreate
